'use client'

import { useEffect, useState } from 'react'

import Button from 'shared/ui/Button'
import Input from 'shared/ui/form/Input'
import { Modal, ModalTitle } from 'shared/ui/Modal'

import {
  validateBlikFormField,
  validateBlikFormValues
} from '../../../payment/validation'

import styles from './SubmitEditSaleOrderModalBlikModal.module.scss'

const SubmitEditSaleOrderModalBlikModal = ({
  open,
  onClose,
  blikCode,
  handleBlikCodeChange,
  onSubmit,
  paymentLoading
}: {
  open: boolean
  onClose: () => void
  blikCode: string
  handleBlikCodeChange: (name: string, value: string) => void
  onSubmit: () => Promise<void>
  paymentLoading: boolean
}) => {
  const [blikValid, setBlikValid] = useState(false)

  useEffect(() => {
    validateBlikFormValues({ blikCode: blikCode }, setBlikValid)
  }, [blikCode])

  return (
    <Modal open={open} onClose={onClose} id='submit-edit-blik-modal'>
      <ModalTitle>Wpisz kod BLIK</ModalTitle>
      <div className={styles.blikInputContainer}>
        <Input
          name='blikCode'
          size='medium'
          value={blikCode}
          onChange={handleBlikCodeChange}
          validate={validateBlikFormField({ blikCode: blikCode })}
          label='Wpisz 6-cio cyfrowy kod BLIK'
          autoFocus
          autoComplete='off'
          inputMode='numeric'
        />
      </div>
      <div className={styles.buttonContainer}>
        <Button
          variant='primary'
          fullWidth
          onClick={onSubmit}
          disabled={paymentLoading || !blikValid}
          loading={paymentLoading}
        >
          Zapłać
        </Button>
        <Button variant='neutralOutline' fullWidth onClick={onClose}>
          Anuluj
        </Button>
      </div>
    </Modal>
  )
}

export default SubmitEditSaleOrderModalBlikModal
